import { render, staticRenderFns } from "./ListInvestigators.vue?vue&type=template&id=14a8cbd6"
import script from "./ListInvestigators.vue?vue&type=script&lang=js"
export * from "./ListInvestigators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports